import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listRoles:[],
  newRole:[],
  selectRoles:[],
  dataRole:[],
  role_id:[]
};
export const mutations = {
  GET_ROLES({ context }, roles) {
    let roles_array = [];
    Object.entries(roles).forEach(([key, val]) => roles_array.push(val));
    return (state.listRoles = roles_array);
  },

  SELECT_ROLES({ context }, roles) {
    state.selectRoles = Object.assign({}, roles);
  },

  SAVE_ROLES({ context }, role) {
    state.newRole = Object.assign({}, role);
  },

  EDIT_ROLE({ context }, dataRole) {
    state.dataRole = Object.assign({}, dataRole);
  },

  DELETE_ROLE({ context }, role_id) {
    state.role_id = Object.assign({}, role_id);
  },

};
export const actions = {
  GET_ROLES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("GET_ROLES", response.data.data.roles);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SELECT_ROLES({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.selectRoles()
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("SELECT_ROLES", response.data.data.roles);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_ROLES({ commit }, role) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(role)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("SAVE_ROLES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_ROLE({ commit }, dataRole) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataRole)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("EDIT_ROLE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_ROLE({ commit }, role_id) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(role_id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_ROLE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }

};
export const getters = {//leer datos
  listRoles: state => state.listRoles,
  selectRoles: tate => state.selectRoles,
  // RolesFilter: (state, getters, store) => {
  //   let roleCurrentUser = store.auth.currentUser.role_id;
  //   let listaRolesCompleta = getters.listRoles;
  //   //let listDeault = ['Admin', 'SuperaDmin', 'las demas'];
  //   let listDefault = listaRolesCompleta;
  //
  //   if(roleCurrentUser == 2){
  //     // let listDefault = listaRolesCompleta.filter( function(name) {
	//     //      return name == "admin";
  //     //    });
  //     // arraymap o array filter a listaRolesCompleta
  //     // comparar o retornar las que coincidan con el array de lista defautl
  //   //listDefault = ['Capturista', 'visor'];
  //   }
  //   return listDefault;
  // },
  newRole: state => state.newRole,
  dataRole: state => state.dataRole,
  role_id: state => state.role_id
};
